// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ResendInvitationButton_buttonsWrapper__LTdhv","button":"ResendInvitationButton_button__Dl0f5"};